export default [
    {
        path: '/convenio/:idConvenio',
        name: 'convenio',
        component: () => import(/* webpackChunkName: "favoritos" */ '../../pages/convenio').then(m => m.default || m),
    },
]
